<div class="payment-method-selector">
    <h3 class="payment-method-selector__title">{{ title }}</h3>
    <sc-payment-option
        class="payment-method-selector__option"
        *ngFor="let option of options"
        [id]="option.id"
        [label]="option.label"
        [type]="type"
        [creditCardTypeKey]="option.creditCardTypeKey"
        [creditCardTypeOptions]="creditCardTypeOptions"
        [isSelected]="option.isSelected"
        [showForm]="!option.id"
        (statusChange)="handleValueChange($event)"
    ></sc-payment-option>
</div>